exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form.mkte_circuitos-buscador.buscador-vertical > .list-group-item .form-group[data-v-6ddf4e08] {\n  padding: 10px 15px 0 45px;\n}\nform.mkte_circuitos-buscador.buscador-vertical > .list-group-item .form-group > label > .fa[data-v-6ddf4e08] {\n  left: 15px;\n  width: 20px;\n}", ""]);

// exports
